<template>
  <div class="instructions">
    <div class="instructions__bubble">
      <div class="instructions__text">
        <p>{{ instructions }}</p>
      </div>
      <img
        class="instructions__clock"
        :src="require(`@/assets/practices/pumpkin_clock/${instructionsClock}`)"
        alt="clock"
      />
      <!-- <img
        class="instructions__clock"
        src="@/assets/practices/pumpkin_clock/clocks/eight_fifty.svg"
        alt="clock"
      />-->
      <div id="instructions__witch-avatar"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lottie from 'lottie-web/build/player/lottie';
// import { Howl } from 'howler';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Instructions',
  // eslint-disable-next-line vue/require-default-prop
  props: { instructionsClock: String },
  data: () => ({
    instructions: 'Click on the pumpkin that has the correct hour.',
  }),
  computed: {
    ...mapGetters({
      exerciseCompleted: 'pumpkinClock/exerciseCompleted',
      gameCompleted: 'pumpkinClock/gameCompleted',
      homeScreenStatus: 'pumpkinClock/homeScreenStatus',
      muteStatus: 'pumpkinClock/muteStatus',
    }),
  },
  watch: {
    homeScreenStatus: newValue => {
      if (newValue) {
        sounds.pumpkinClockClock.pause();
      } else {
        sounds.pumpkinClockClock.play();
      }
    },
    muteStatus: newValue => {
      if (newValue) {
        sounds.pumpkinClockClock.pause();
      }
      if (this.gameCompleted) {
        sounds.pumpkinClockClock.pause();
      } else {
        sounds.pumpkinClockClock.play();
      }
    },
    gameCompleted: newValue => {
      if (newValue) {
        sounds.pumpkinClockClock.pause();
      } else {
        sounds.pumpkinClockClock.pause();
      }
    },
  },
  mounted() {
    const witchGameAnimation = lottie.loadAnimation({
      container: document.getElementById('instructions__witch-avatar'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: '/assets/practices/pumpkin_clock/animations/witch_game.json',
    });
    witchGameAnimation.play();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.instructions {
  align-items: center;
  color: $pumpkin-clock-color-main;
  display: flex;
  font-family: 'RimouskiSb-Regular';
  height: 20vh;
  justify-content: center;
  width: 85vw;

  .instructions__bubble {
    align-items: center;
    background-color: #00000070;
    border: 1vh solid $pumpkin-clock-color-main;
    border-radius: 7.5vh;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    transform: translateY(-4vh);
    transform-origin: right;
    width: 65%;
  }

  .instructions__text {
    width: 55%;
    padding: 1em;
    position: absolute;
    text-align: center;
  }

  .instructions__clock {
    position: absolute;
    height: 150%;
    left: -17.5%;
  }

  #instructions__witch-avatar {
    bottom: -6vh;
    height: 35vh;
    position: absolute;
    right: -30%;
    width: 35vh;
  }
}

@media (max-aspect-ratio: 8/5) {
  .instructions {
    .instructions__bubble {
      .instructions__text {
        transform: translateX(10%);
      }
      #instructions__witch-avatar {
        right: -45%;
      }
    }
  }
}
</style>
